import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/profile/cs_close_n.png'


const _hoisted_1 = { class: "deposit-popup" }
const _hoisted_2 = { class: "popup-header" }
const _hoisted_3 = { class: "popupContainer" }
const _hoisted_4 = { class: "subText" }

import { ref} from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { checkDate } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { callDoNotshowFunc } from '@/view/deposit/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'dailyRechargePopup',
  emits: ['checkPopupFlow'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const emits = __emit
const open = () => {
        show.value = true
}

const close = () => {
    // userStore.setFirstRechargePopupShowStatus(0)
    userStore.setRechargeBonusType(0)
    let takeFirstDepositStatus = userStore.takeFirstDeposit
    if(!takeFirstDepositStatus){
        userStore.setisFirstRechargeRewardEligible(false)
    }else{
        userStore.setisFirstRechargeRewardEligible(true)
    }
    show.value = false  
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const handleIgnoreToday = () => {
    const today = new Date();
    const todayDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    localStorage.setItem('ignoreDate_daily', todayDate);
    show.value = false
    userStore.setisFirstRechargeRewardEligible(false)
    userStore.setRechargeBonusType(0)
    emits('checkPopupFlow')
}
const depositEnter = () => {
    userStore.setRechargeBonusType(3)
    show.value = false
}
const callDoNotshow = async () => {
    await callDoNotshowFunc(loadingRef, showSuccess, showError, userStore, show, 3)
    await userStore.getInfo()
    emits('checkPopupFlow')
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "center",
      style: {
      minWidth: '90%',
      background: 'transparent',
      color: '#fff',
      overflow: 'hidden',
      zIndex: '2008'
    },
      onClickOverlay: close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_row, { style: {"display":"flex","align-items":"center"} }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, { span: "22" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('deposit.dailyRechargeTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: "2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "",
                      width: "20",
                      onClick: close
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('deposit.getMoreBonus')), 1),
            _createVNode(_component_van_row, { class: "btnGroup" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "btnCol"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "click_btn",
                      onClick: callDoNotshow
                    }, _toDisplayString(_ctx.$t('deposit.dontShowAgain')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "btnCol"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "click_btn",
                      onClick: handleIgnoreToday
                    }, _toDisplayString(_ctx.$t('deposit.ignoreToday')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "8",
                  class: "btnCol"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "click_btn",
                      onClick: depositEnter
                    }, _toDisplayString(_ctx.$t('deposit.enter')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})